import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  user: any;
  adminUrl: any;
  zoomLevel = 1;

  mobView: boolean = false;
  supportedLanguages = [
    { name: 'English', code: 'en' },
    { name: 'Hindi', code: 'hi' },
    // Add more languages as needed
  ];
  appDiv: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    const viewType = this.route.snapshot.queryParamMap.get('view-type');
    this.mobView = viewType === 'mobile';
  }

  ngOnInit(): void {
    this.adminUrl = environment.depatmentlogin.redirectadminUrl;
    this.authService.hasLogin.subscribe((res) => {
      this.user = (res) ? this.authService.user : null;
    });
    this.appDiv = document.getElementsByClassName('app')[0] as HTMLElement;
  }
  switchLanguage($event: any) {
    this.translate.use($event.target.value);
  }
  fLogout() {
    this.authService.logout().then((res) => {
      if (res) {
        this.router.navigate([environment.auth.logoutUrl]);
      }
    });
  }

  zoom(zoomType:string)
  {
    switch(zoomType) {
      case 'zoom-in':
        this.zoomLevel += 0.1;
        if (this.zoomLevel > 1.2) {
          this.zoomLevel = 1.2;
        }
        break;
      case 'zoom-out':
        this.zoomLevel -= 0.1;
        if (this.zoomLevel < 0.8) {
          this.zoomLevel = 0.8;
        }
        break;
      case 'reset':
        this.zoomLevel = 1;
        break;
    }
    this.appDiv.style.zoom = this.zoomLevel;
  }
}
